import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions';
import axios from "../services";
import { sessionExpiredMsg } from "../constants/constants";

function* getContestDetail(action) {
    let responseList = [];
    let detailsResponse = yield axios.get(`/contests/${action.payload}/details`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (detailsResponse == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (detailsResponse.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError());
        yield put(actions.modalOpen({ message: judgesCommitteeResponse.message }));
        yield put(actions.modalOpen({ message: detailsResponse.response.data.msg }));
    } 

    let judgesCommitteeResponse = yield axios.get(`/contests/${action.payload}/get-judges-committee1`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (judgesCommitteeResponse == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (judgesCommitteeResponse.status !== 200) {
        yield put(actions.hideAppLoader());
         yield put(actions.contestDetailError());
         yield put(actions.modalOpen({ message: judgesCommitteeResponse.message }));
        yield put(actions.modalOpen({ message: judgesCommitteeResponse.response.data.msg }));
    }

    let contestentsResponse = yield axios.get(`/contests/${action.payload}/get-contestents`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (contestentsResponse == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (contestentsResponse.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError());
        yield put(actions.modalOpen({ message: contestentsResponse.message }));
        yield put(actions.modalOpen({ message: contestentsResponse.response.data.msg }));
    } 

    let talentResponse = yield axios.get(`/contests/${action.payload}/all-talent?&skip=0&limit=5`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (talentResponse == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (talentResponse.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: talentRespons.message }));
        yield put(actions.modalOpen({ message: talentResponse.response.data.msg }));
    }


    let newContestantsList = yield axios.get(`/users/new-contestantsList/${action.payload}?skip=0&limit=3`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (newContestantsList == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (newContestantsList.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: newContestantsList.message }));
        yield put(actions.modalOpen({ message: newContestantsList.response.data.msg }));
    }

    let userVoteList1k = yield axios.get(`/users/${action.payload}/get-user-vote-list?skip=0&limit=4`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (userVoteList1k == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (userVoteList1k.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: userVoteList1k.message }));
        yield put(actions.modalOpen({ message: userVoteList1k.response.data.msg }));
    }

    let myVotesContestant = yield axios.get(`/votes/my-votes-contestant/${action.payload}?skip=0&limit=6`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (myVotesContestant == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (myVotesContestant.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: myVotesContestantk.message }));
        yield put(actions.modalOpen({ message: myVotesContestant.response.data.msg }));
    }

    let countryWiseContestant = yield axios.get(`/contests/${action.payload}/country-wise-contestant-count`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (countryWiseContestant == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (countryWiseContestant.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: countryWiseContestant.message }));
        yield put(actions.modalOpen({ message: countryWiseContestant.response.data.msg }));
    }


    let dailyWinners = yield axios.post(`/contests/all-contest-daily-winner1`, {
        contest: `${action.payload}`
    })
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (dailyWinners == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (dailyWinners.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: dailyWinners.message }));
        yield put(actions.modalOpen({ message: dailyWinners.response.data.msg }));
    }

    let monthlyWinners = yield axios.get(`/contests/monthly-winners-list/${action.payload}?limit=3&currentYear=${new Date().getFullYear()}`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (monthlyWinners == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (monthlyWinners.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: monthlyWinners.message }));
        yield put(actions.modalOpen({ message: monthlyWinners.response.data.msg }));
    }

    let monthWinner = yield axios.get(`/contests/monthly-winner/${action.payload}`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (monthWinner == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (monthWinner.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: monthWinner.message }));
        yield put(actions.modalOpen({ message: monthWinner.response.data.msg }));
    }


    let previousWinners = yield axios.get(`/users/previous-winners/${action.payload}`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (previousWinners == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (previousWinners.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: previousWinners.message }));
        yield put(actions.modalOpen({ message: previousWinners.response.data.msg }));
    }

    let rankList = yield axios.get(`/users/${action.payload}/see-more?type=rankWiseContestantList&skip=0&limit=3`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (rankList == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (rankList.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: rankList.message }));
        yield put(actions.modalOpen({ message: rankList.response.data.msg }));
    }

    let votersActivity = yield axios.get(`/contests/${action.payload}/get-voters-activity?weekIndex=0`)
        .then(async response => response)
        .catch(async error => {
            return error;
        });

    if (votersActivity == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else if (votersActivity.status !== 200) {
        yield put(actions.hideAppLoader());
        yield put(actions.contestDetailError())
        yield put(actions.modalOpen({ message: votersActivity.message }));
        yield put(actions.modalOpen({ message: votersActivity.response.data.msg }));
    }

    
    responseList.push(detailsResponse);
    responseList.push(judgesCommitteeResponse);
    responseList.push(contestentsResponse);
    responseList.push(talentResponse);
    responseList.push(newContestantsList);
    responseList.push(userVoteList1k);
    responseList.push(myVotesContestant);
    responseList.push(countryWiseContestant);
    responseList.push(dailyWinners);
    responseList.push(monthlyWinners);
    responseList.push(monthWinner);
    responseList.push(previousWinners);
    responseList.push(rankList);
    responseList.push(votersActivity);
    
    // console.log('dsdsRESpone comittteee', responseList)
    let result = yield Promise.all(responseList);
    let test = new Date();
    let d = new Date(Date.UTC(test.getUTCFullYear(), test.getUTCMonth(), test.getUTCDate(), test.getUTCHours(), test.getUTCMinutes(), test.getUTCSeconds(), test.getUTCMilliseconds()));
    let countDownTimer = result[0].data.data.endOfMonth != undefined ? (result[0].data.data.endOfMonth * 1000 - d.valueOf()) / 1000 : 0;

    let response = {
        contestDetails: { ...result[0].data.data, countDownTimer },
        judgesCommittee: result[1].data.data,
        contestents: result[2].data.data,
        talent: result[3].data.data,
        newContestantsList: result[4].data.data,
        userVoteList: result[5].data.data,
        myVotesContestant: result[6].data.data,
        countryWiseContestant: result[7].data.data,
        dailyWinners: result[8].data.data,
        monthlyWinners: result[9].data.data,
        monthWinner: result[10].data.data,
        previousWinners: result[11].data.data,
        rankList: result[12].data.data,
        votersActivity: {
            ...result[13].data.data,
            ChartData: {
                datasets: [{
                    data: Array.from(result[13].data.data.chartData, item => item.countOfVotes),
                    backgroundColor: "#b3d9fe",
                }],
                labels: Array.from(result[13].data.data.chartData, item => item.weekDayName),
            },
            LocationRelatedData: {
                datasets: [{
                    label: "Male",
                    data: Array.from(result[13].data.data.locationRelatedData, item => item.maleVotes),
                    backgroundColor: "#5aafff",
                }, {
                    label: "Female",
                    data: Array.from(result[13].data.data.locationRelatedData, item => item.femaleVotes),
                    backgroundColor: "#b3d9fe",
                }],
                labels: Array.from(result[13].data.data.locationRelatedData, item => item.countryName),
            }
        }
    };
    yield put(actions.getContestDetailSuccess(response));
    yield put(actions.hideAppLoader());
}

function* getJudges(action) {
    try {
        yield put(actions.getJudgesCommitteeSuccess([
            {
                name: 'John Smith',
                image: require("../img/all1.jpg")
            },
            {
                name: 'Smith John',
                image: require("../img/contest1.jpg")
            },
            {
                name: 'John Smith1',
                image: require("../img/slide1.jpg")
            },
        ]));
    } catch (error) {
        console.log("ERROR FROM SAGA Contests", error.message);
    }
}

function* getContesteeFeed(action) {
    try {
        yield put(actions.getContesteeFeedSuccess([
            {
                name: 'Jim Carry',
                contestName: 'Face Contest',
                votesCount: '2600',
                myVotes: '12',
            },
            {
                name: 'Carry Minati',
                contestName: 'Face Contest',
                votesCount: '2700',
                myVotes: '15',
            }
        ]))
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* getEnrolledContests(action) {
    try {
        let response = yield axios.get("/users/user-enrolled-contests", {})
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getEnrolledContestsSuccess(response.data.data))
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);

    }
}

function* removeEnrolledContests(action) {
    try {
        let response = yield axios.post(`/users/contest/${action.payload.contestName}/change-enrollment-status`, {
            firstName: action.payload.firstName,
	        lastName: action.payload.lastName,
	        flag: false
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2 }));
            yield put(actions.getEnrolledContests());
            yield put(actions.hideAppLoader());
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* giveVote(action) {
    const { from } = action.payload
    if (from == "explore") {
        yield put(actions.giveVoteSuccessExplore(action.payload.index));
    } else if (from == "featureVideo") {
        yield put(actions.giveVoteSuccessFeatureVideo(action.payload.index));

    } else if (from == "contestDetails") {
        yield put(actions.giveVoteSuccessContestDetails(action.payload.index))
    } else if (from == "contestDetails") {
        yield put(actions.giveVoteSuccessSingleMedia(action.payload.index))
    }
    let response = yield axios
        .post(`/votes`, action.payload)
        .then(async response => response)
        .catch(async error => {
            return error;
        });
    if (response.status == 200) {
        yield put(actions.modalOpen({ message: response.data.msg, notifyType: 2 }));
        yield put(actions.hideAppLoader());
        yield put(actions.getUser());
    } else if (response == "Error: Request failed with status code 401") {
        yield put(actions.hideAppLoader());
        put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
    } else {
        yield put(actions.hideAppLoader());
        yield put(actions.modalOpen({ message: response.response.data.msg }));
    }
}

function* getEnrolledHostContest() {
    try {
        let response = yield axios
            .get("/users/user-enrolled-hosts")
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getEnrolledContestDataSuccess(response.data.data))
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* seeMoreData(action) {
    try {
        let response = yield axios
            .get(`/users/${action.payload.contest}/see-more?type=${action.payload.type}&country=${action.payload.country}&skip=${action.payload.Length}&limit=10`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
            
        if (response.status == 200) {
            yield put(actions.seeMoreDataSuccess({
                seeMoreData: response.data.data,
                newData: action.payload.newData
            }))

        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* getContestDetailMonthlyWinners(action) {
    try {
        let response = yield axios
            .get(`/contests/monthly-winners-list/${action.payload.contestName}?limit=50&currentYear=${action.payload.year}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            yield put(actions.getContestDetailMonthlyWinnersSuccess(response.data.data))
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* getVotersActivity(action) {
    try {
        let response = yield axios.get(`/contests/${action.payload.contestName}/get-voters-activity?weekIndex=${action.payload.weekIndex}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getVotersActivitySuccess({
                votersActivity: {
                    ...response.data.data,
                    ChartData: {
                        datasets: [{
                            data: Array.from(response.data.data.chartData, item => item.countOfVotes),
                            backgroundColor: "#b3d9fe"
                        }],
                        labels: Array.from(response.data.data.chartData, item => item.weekDayName),
                    },
                    LocationRelatedData: {
                        datasets: [{
                            label: "Male",
                            data: Array.from(response.data.data.locationRelatedData, item => item.maleVotes),
                            backgroundColor: "#5aafff"
                        }, {
                            label: "Female",
                            data: Array.from(response.data.data.locationRelatedData, item => item.femaleVotes),
                            backgroundColor: "#b3d9fe"
                        }],
                        labels: Array.from(response.data.data.locationRelatedData, item => item.countryName),
                    }
                },
                votersActivityIndex: action.payload.weekIndex,
            }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

function* getContestDetailsTalents(action) {
    try {
        const { contestName, Length } = action.payload;
        let response = yield axios
            .get(`/contests/${contestName}/all-talent?&skip=${Length}&limit=5`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getContestDetailsTalentsSuccess({ allContestants: response.data.data, newData: false }))
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("Error From Saga Contests", error.message);
    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_CONTEST_DETAIL, getContestDetail);
    yield takeEvery(actionTypes.GET_JUDGES_COMMITTEE, getJudges);
    yield takeEvery(actionTypes.GET_CONTESTEE_FEED, getContesteeFeed);
    yield takeEvery(actionTypes.ENROLL_CONTEST_GET_ENROLLED_CONTESTS, getEnrolledContests);
    yield takeEvery(actionTypes.ENROLL_CONTEST_REMOVE_ENROLLED_CONTESTS, removeEnrolledContests);
    yield takeEvery(actionTypes.GIVE_VOTE, giveVote);
    yield takeEvery(actionTypes.GET_ENROLLED_HOST_DATA, getEnrolledHostContest)
    yield takeEvery(actionTypes.SEE_MORE_DATA, seeMoreData)
    yield takeEvery(actionTypes.GET_CONTEST_DETAIL_MONTHLY_WINNERS, getContestDetailMonthlyWinners)
    yield takeEvery(actionTypes.GET_VOTERS_ACTIVITY, getVotersActivity)
    yield takeEvery(actionTypes.GET_CONTEST_DETAIL_TALENTS, getContestDetailsTalents)
}